import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import {EventType} from '@ispm/shared/bpmn-io/bpmn-js';
import {TreeNavigator} from "@ispm/shared/bpmn-io/services/tree-navigator";

export class ReplaceShapeBehavior extends CommandInterceptor {

    constructor(eventBus: EventBus, private treeNavigator: TreeNavigator) {
        super(eventBus);
        super.preExecute([EventType.SHAPE_REPLACE], this.assignOldSize.bind(this));
        super.postExecuted([EventType.SHAPE_REPLACE], this.updateNeighborhoodID.bind(this));
    }

    assignOldSize(event) {
        const context = event.context;
        const oldShape = context.oldShape;
        const newShape = context.newData;
        newShape.width = oldShape.width;
        newShape.height = oldShape.height;
    }

    updateNeighborhoodID(event){
      const context = event.context;
      const newShape = context.newShape;
      newShape.businessObject.neighborhoodID = this.treeNavigator.currentLayer


    }
}
ReplaceShapeBehavior.$inject = [...CommandInterceptor.$inject, 'treeNavigator'];

